import React from 'react';

import { Icon, IconProps } from '../../icon';

export const GooglePlayStoreIcon = (props: IconProps) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 44 44"
    {...props}
  >
    <path
      d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H36C40.1421 0.5 43.5 3.85786 43.5 8V36C43.5 40.1421 40.1421 43.5 36 43.5H8C3.85786 43.5 0.5 40.1421 0.5 36V8Z"
      stroke="black"
      fill="none"
    />
    <g transform="translate(10, 9)">
      <path
        d="M10.5857 12.6467L0.470703 23.7849C0.784126 24.9973 1.84786 25.8844 3.11105 25.8844C3.61443 25.8844 4.08931 25.7464 4.49771 25.4901L4.5262 25.4704L15.9044 18.6594L10.5762 12.6368L10.5857 12.6467Z"
        fill="#EA4335"
      />
      <path
        d="M20.8163 10.754H20.8068L15.8965 7.78711L10.3594 12.9028L15.9155 18.669L20.8068 15.7416C21.6616 15.2586 22.2409 14.3222 22.2409 13.2478C22.2409 12.1734 21.6711 11.237 20.8163 10.7639V10.754Z"
        fill="#FBBC04"
      />
      <path
        d="M0.471929 2.65234C0.414943 2.88891 0.376953 3.12547 0.376953 3.38175V23.0658C0.376953 23.3221 0.405446 23.5586 0.471929 23.7952L10.9288 12.9428L0.471929 2.65234Z"
        fill="#4285F4"
      />
      <path
        d="M10.6617 13.2208L15.8949 7.78967L4.5262 0.949051C4.1178 0.692774 3.63342 0.544922 3.11105 0.544922C1.84786 0.544922 0.784126 1.44189 0.470703 2.64442L10.6617 13.2109V13.2208Z"
        fill="#34A853"
      />
    </g>
  </Icon>
);
